import { makeAutoObservable } from "mobx";

export default class AffiliateStore {
    constructor() {
        this._promorequests = [];
        this._userpayouts = [];
        this._referrerdata = {};


        makeAutoObservable(this);
    }

    // Сеттеры
    setPromoRequests(codes) {
        this._promorequests = codes;
    }
    setUserPayouts(payouts) {
        this._userpayouts = payouts;
    }
    setReferrerData(referrerdata) {
        this._referrerdata = referrerdata;
    }


    // Геттеры
    get promoRequests() {
        return this._promorequests;
    }
    get userPayouts() {
        return this._userpayouts;
    }
    get referrerData() {
        return this._referrerdata;
    }


}
